<template>
  <o-form-group
    :form-state="formState"
    :label="label"
    :message="errorMessages"
    :nolabel="nolabel"
    :id="this_id"
    :type="{ 'is-danger': hasError }"
  >
    <b-input-group>
      <b-form-input
        :class="input_class"
        :readonly="isInputReadonly"
        v-bind="$attrs"
        v-bind:value="value"
        v-on="inputListeners"
        v-model="searchKeyword"
      >
      </b-form-input>
      <b-button v-if="showSearchButton" @click="searchExtra">Search</b-button>
      <b-button v-if="showXButton" @click="editInput">X</b-button>
    </b-input-group>

    <table v-if="showTable" class="table table-bordered table-condensed">
      <tr>
        <th>Extra Ref Number</th>
        <th>Extra No.</th>
        <th>PO Number</th>
        <th>Action</th>
      </tr>
      <tr v-for="extraItem in items">
        <td>{{ extraItem.code }}</td>
        <td>{{ extraItem.id }}</td>
        <td>{{ extraItem.purchase_order_number }}</td>
        <td>
          <button class="btn btn-primary" @click="select(extraItem)">
            SELECT
          </button>
        </td>
      </tr>
    </table>

    <span v-if="formState.debug">
      SE:{{ serverErrors }} [{{ serverErrorsIndex }}].{{ name }}<br />
      AL_SE:{{ all_server_errors }}
    </span>
  </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../vue-ocom/mixins/form_component_mixin";
import OFormGroup from "../../../vue-ocom/components/forms/OFormGroup";
import { CreateCodeTableFetchMixin } from "../../../vue-ocom/mixins";
import Swal from "sweetalert2";

export default {
  name: "ExtraSearch",
  components: { OFormGroup },
  mixins: [
    FormComponentMixin,
    CreateCodeTableFetchMixin(["Customer", "Supervisor"]),
  ],
  props: { create: Boolean, extra_number: String },
  computed: {},
  data() {
    return {
      isCreateForm: this.create,

      isInputReadonly: false,
      searchKeyword: "",

      showSearchButton: true,
      showXButton: false,

      items: [],
      showTable: false,
    };
  },
  methods: {
    searchExtra() {
      var list_options = {
        limit: 51,
        offset: 0,
        q: this.searchKeyword,
        _code: false,
      };
      this.$store
        .dispatch("ServiceExtraModule/getAll", list_options)
        .then(() => {
          this.items = this.$store.getters["ServiceExtraModule/items"];

          if (this.items.length > 50) {
            this.over50ExtraResults();
          }
          if (this.items.length < 1) {
            this.noExtraResults();
          }

          this.showTable = true;
        });
    },
    editInput() {
      this.isCreateForm = true;
      this.isInputReadonly = false;
      this.showXButton = false;
      this.showSearchButton = true;
    },
    select(extraItem) {
      this.searchKeyword = extraItem.code;
      this.$emit("update-extra", extraItem);

      this.showTable = false;
      this.isInputReadonly = true;
      this.showSearchButton = false;
      this.showXButton = true;
    },
    over50ExtraResults() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Service Extras Found!",
        text:
          "We found over 50 Service Extras matching your criteria, Try being more specific.",
        showConfirmButton: true,
      });
    },
    noExtraResults() {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "No Service Extras Found",
        text:
          'No Extras found match the text "' +
          this.searchKeyword +
          '". Please try again. Try to be less specific ie search by Street name',
      });
    },
  },
  updated() {
    if (this.isCreateForm == false) {
      this.searchKeyword = this.extra_number;
      this.isInputReadonly = true;
      this.showSearchButton = false;
      this.showXButton = true;
    }
  },
};
</script>

<style scoped></style>
